import { isProduction } from '@/config/environment';

const EXCLUDED_DOMAINS = ['fa9r.com', 'beyondpresence.ai'];

const EXCLUDED_EMAILS = [
  'shahrozt20@gmail.com', // Sherry
  'mshehrozsajjad@gmail.com', // Sherry
  'lucasjacobson3@gmail.com', // Lucas
  'engr.awaisshafique@gmail.com', // Awais
  'awais.shafique03@gmail.com', // Awais
  'anna.tyrkich@gmail.com', // Anna
  'annaworkingaddress@gmail.com', // Anna
  'april.bachhuber@gmail.com', // April
  'aprilbachhuberwork@gmail.com', // April
  'renefilip@mail.com', // René
  'egeyaygin@hotmail.com', // Ege
  'egeyaygin5@gmail.com', // Ege
];

const hasExcludedDomain = (email: string) => {
  const domain = email.split('@')[1];
  if (!domain) return false;
  return EXCLUDED_DOMAINS.some((excluded) => domain.endsWith(excluded));
};

export const isExcludedEmail = (email: string) => {
  if (!isProduction) return false;
  const normalizedEmail = email.toLowerCase();
  return (
    hasExcludedDomain(normalizedEmail) ||
    EXCLUDED_EMAILS.includes(normalizedEmail)
  );
};
